import { doesAssetExist } from "../s3/useS3AssetsManager";

export const DEFAULT_ICON = "FE.2a85235d-7d04-4b32-8dbd-65382b6f8949";

const cache = {};

export const getFeatureIcon = (featureId: string) =>
  `https://assets.kahun.com/featureIcons/${featureId}.svg`;

export const hasFeatureIcon = async (featureId: string) =>
  await doesAssetExist(getFeatureIcon(featureId));

export const getFeatureIconOrDefault = (featureId: string): Promise<string> => {
  if (!(featureId in cache))
    cache[featureId] = fetch(getFeatureIcon(featureId), {
      method: "HEAD",
      headers: { "Cache-Control": "no-cache" },
    })
      .then((res) => {
        return getFeatureIcon(res.ok ? featureId : DEFAULT_ICON);
      })
      .catch((e) => {
        console.log(e);
        return getFeatureIcon(DEFAULT_ICON);
      });
  return cache[featureId];
};
